import * as React from 'react';
import { loadableReady } from '@loadable/component';
import { createRoot } from 'react-dom/client';
import { Router } from 'react-router-dom';
import { UniversalContextWrapper } from '../app';
import { unescapeUnknown } from '../modules/escape';
import { createBrowserHistory } from '../modules/history';
import { getLocaleHtml } from '../modules/intl';
import { getStore } from '../store';

declare global {
  interface Window {
    __initial_state__?: Record<string, unknown> | undefined;
    __kv__: {
      tmxOrgId: string;
      ovdfInstanceId: string;
      ovdfPageId: string;
      appInsightsConnectionString: string;
      oneDSAppInsightsInstrumentationKey: string;
    };
  }
}

export async function bootstrap(app: React.ComponentType) {
  const history = createBrowserHistory();
  const locale = getLocaleHtml();
  const unescapedState = unescapeUnknown(window.__initial_state__) as Record<string, unknown>;
  const rootTag = document.getElementById('root') as HTMLDivElement;
  const root = createRoot(rootTag);

  loadableReady(() => {
    root.render(
      <Router history={history}>
        <UniversalContextWrapper
          app={app}
          keys={unescapeUnknown(window.__kv__)}
          locale={locale}
          store={getStore(unescapedState)}
        />
      </Router>
    );
  });
}
